module.exports = __webpack_public_path__ + "img/temple-length.202c8d7.svg?v=1764327952164";